export default {

  App: {
    Title: 'PIRELLI'
  },

  Button: {
    View    : 'View',
    Close   : 'Close',
    Send    : 'Send',
    Yes     : 'Yes',
    No      : 'No',
    Ok      : 'Ok',
    Next    : 'Next',
    Prev    : 'Prev',
    Register: 'Register',
  },

  Error: {
    Generic        : 'General Error. Please try again.',
    MaintenanceMode: 'Under maintenance. Please try again later.',
  },

  Misc: {
    Locale   : 'Language',
    CreatedAt: '@:Common.Button.Create',
    UpdatedAt: '@:Common.Button.Update',
    DeletedAt: '@:Common.Button.Delete',
  }
}
